module.exports = __webpack_public_path__ + "static/media/27GalleryPuppets.6b7a5349.jpeg";